import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { HelmetProvider } from 'react-helmet-async';

if (typeof window !== 'undefined') {
  window.addEventListener('error', (e) => {
    const msg = e.message || '';
    if (msg.includes('Failed to connect to MetaMask')) {
      e.preventDefault();
    }
  });
  window.addEventListener('unhandledrejection', (e) => {
    const reason = e.reason;
    const msg = (reason && (reason.message || String(reason))) || '';
    if (msg.includes('Failed to connect to MetaMask')) {
      e.preventDefault();
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

